import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'
import StateStorage from 'lib/state-storage'
import ShopLanguageMap from 'lib/i18n/shop-language-map'

const segmentProductImageGalleryViewed = ({
  ref_id,
  ref_type,
  id_product,
  image_type,
}) => {
  const shop = StateStorage.getShop()
  const user = StateStorage.getAuthUser()
  const id_shop = ShopLanguageMap.getIdShopBySlug(shop)
  const data = {
    ref_id: Number(ref_id),
    ref_type,
    id_shop,
    id_product,
    image_type,
    id_customer: user?.id_customer,
  }

  segmentTrackAction(EVENT.productImageGalleryViewed, data)
}

export default segmentProductImageGalleryViewed
